import {
  UPDATE_CUSLOADING_STATUS,
  FETCH_CUSAPPMANGE_DATA_LIST,
  GET_CUSBLACKLISTNULL_LIST
} from "../actions/customizePanel";

const defVal = {
  dataListLoading: false,
  dataList: [],
  dataListTotal: 0,
  isDataList: true
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_CUSLOADING_STATUS:
      return Object.assign({}, state, {
        dataListLoading: action.loading
      });

    case FETCH_CUSAPPMANGE_DATA_LIST:
      return Object.assign({}, state, {
        dataList: action.dataList,
        dataListTotal: action.dataListTotal,
      });
    case GET_CUSBLACKLISTNULL_LIST:
      return Object.assign({}, state, {
        isDataList: action.isDataList || false,
      });
    default:
      return state;
  }
};
